import {classNames, pluralize, React, useEffect, useLocalStore, observer} from '@api'
import {GroupByGroupStore, useGroupByGroupStore, useVipLocalStore} from '@modules'

import {VipLocalStore} from '@modules'
import {StoresInstance} from '@stores/StoresInstance'
import {computed} from 'mobx'
import * as css from './GroupByGroupHeaderDropIndicator.css'
import {Spinner} from '@blueprintjs/core'
import {Check} from '@material-ui/icons'

class GroupByGroupHeaderDropIndicatorStore extends VipLocalStore {
  constructor(stores: StoresInstance,public groupStore: GroupByGroupStore) {
    super(stores)
  }

  get groupDragDropEvents() {
    return this.groupStore.groupDragDropEvents
  }

  lastLabel: string

  @computed get label() {
    const {catalog} = this
    if (!this.groupStore.showDropIndicator) {
      return this.groupDragDropEvents.allowDrop.message ?? this.lastLabel ?? `Assign '' to ${catalog.catalogItemName}`
    }

    const {groupStore: {fullPath, props: {info, info: {title}, level}}, dragDrop} = this,
      {catalogItemName, groupBy: {hierarchyGroups}} = catalog,
      {dragItem, dragItem: {id, dragType, count}, ddInteractions} = dragDrop,
      dropCount = (info.count ?? 0) + (info.offline_count ?? 0)

    if (dragType === catalog.index) {
      // Assigning the current groups attribute(s) to the dragged item set

      const dynamicSectionGroup = hierarchyGroups.slice(0, level + 1).find(hg => hg.sectionConfig?.viewOptions?.field),
        dynamicSectionName = dynamicSectionGroup ? _.get(fullPath, `${dynamicSectionGroup.sectionConfig.path}.${dynamicSectionGroup.sectionConfig.viewOptions.field}`) : null

      //return `Assign '${title}' ${dynamicSectionName ? `(${dynamicSectionName}) ` : ''}to ${!dragItem.label || count > 1 ? `${count} ${pluralize(catalogItemName, count)}` : `'${dragItem.label}'`}`
      return `Assign to ${!dragItem.label || count > 1 ? `${count} ${pluralize(catalogItemName, count)}` : `'${dragItem.label}'`}`
    }

    const assignLabel = `Assign '${dragItem.label ?? dragItem.dragType}' to ${dropCount} ${pluralize(catalogItemName, dropCount)} in ${title}`,
      createLabel = `+${count} New ${catalogItemName}${!catalogItemName.endsWith('s') && count > 1 ? 's' : ''}`

    if (dragType === 'images') {
      return `Create ${catalogItemName}(s)`
    } else if (ddInteractions[dragType]?.['GroupHeader']) {
      const {operation} = ddInteractions[dragType]['GroupHeader']
      if (operation == 'assign') {
        return assignLabel
      }

      return createLabel
    } else if (ddInteractions[dragType]?.['Catalog_CreateItems']) {
      // Create ## items in group
      //return `+${count} ${catalogItemName}${!catalogItemName.endsWith('s') && count > 1 ? 's' : ''} from ${libraryByIndex[dragType].label ?? dragType}`
      return createLabel
    } else {
      // Apply dragged item on to selected items in the group
      return assignLabel
    }
  }
}

export const GroupByGroupHeaderDropIndicator = observer<{ className?: string }>(function GroupByGroupHeaderDropIndicator({className}) {
  const groupStore = useGroupByGroupStore(),
    store = useVipLocalStore((ws) => new GroupByGroupHeaderDropIndicatorStore(ws, groupStore)),
    {groupStore: {ddHandler, showDropIndicator}} = store

  // useEffect(() => {
  //   if (store.label) {
  //     store.lastLabel = store.label
  //   }
  // }, [showDropIndicator])

  /**
   * Drag catalog item(s) between groups -> reassign ##
   * Drag catalog item(s) from another window -> assign attribute to ## items
   * Drag Library item(s) on to header -> Create placeholders with link to the library item
   * Drag plain text on to header -> Create N placeholder (1 per line)
   * Drag image(s) on to header -> Create 1 or N placeholders
   */
  return (<div className={classNames(css.root, className, 'dropIndicator')}
               data-has-label='false'
               data-visible={showDropIndicator}
               data-is-allowed={ddHandler?.isDropAllowed === true}
  >
    {/*<label>
      {showDropIndicator ? store.label : store.lastLabel}
    </label>*/}
  </div>)
})

export const GroupByGroupHeaderDropStatusIndicator = observer(function GroupByGroupHeaderDropStatusIndicator() {
  const groupStore = useGroupByGroupStore(),
    store = useVipLocalStore((ws) => new GroupByGroupHeaderDropIndicatorStore(ws, groupStore)),
    {groupStore: {success, dragDropLoading, grouping: {subtitleFields}}} = store

  return <div className={css.statusRoot}
              //data-has-subtitle={!_.isEmpty(subtitleFields)}
              data-type='GroupByHeaderStatus'
              data-id={store.groupStore.ddHandler?.def?.id}
              data-loading={dragDropLoading}
              data-success={success}>
    {dragDropLoading && <div className={css.loading}>
      <Spinner intent='primary' size={20}/>
    </div>}

    <div className={classNames(
      css.success,
      {[css.success_image]: true}
    )}>
      <div className={css.green_check}>
        <Check/>
      </div>
    </div>
  </div>
})

// GroupByGroupHeaderDropIndicator['whyDidYouRender'] = true



// WEBPACK FOOTER //
// ./src/modules/catalog/internal/gridList/components/groupBy/GroupByCatalog/GroupByCatalog_Groups/GroupByCatalog_LoadMore/GroupByGroupHeaderDropIndicator.tsx